import { HistoryType } from '@shared/utils/History/HistoryType';
import { DataCache } from '../../DataCache';
import { TvQuoteUtils } from '../../UtilsClasses/TvQuoteUtils';
import { TvSymbolConvertor } from '../Convertors/TvSymbolConvertor';
import { TvAccountHelper } from '../Helpers/TvAccountHelper';
import throttle from 'lodash.throttle';
export class TvInstrumentQuoteManager {
    constructor(instrument, host) {
        this.isDelayed = false;
        this.throttledSendRealtimeUpdate = throttle(() => {
            this.sendRealtimeUpdate();
        }, TvInstrumentQuoteManager.THROTTLE_DELAY, { leading: true, trailing: true });
        this.instrument = instrument;
        this.host = host;
        this.subscribeRealtime();
    }
    subscribeRealtime() {
        this.isDelayed = TvSymbolConvertor.getQuoteDelay(this.instrument) > 0;
        DataCache.FQuoteCache.addListener(this.instrument, this, HistoryType.QUOTE_LEVEL1);
        DataCache.FQuoteCache.addListener(this.instrument, this, HistoryType.QUOTE_TRADES);
    }
    unsubscribeRealtime() {
        DataCache.FQuoteCache.removeListener(this.instrument, this, HistoryType.QUOTE_LEVEL1);
        DataCache.FQuoteCache.removeListener(this.instrument, this, HistoryType.QUOTE_TRADES);
    }
    newQuote() {
        this.throttledSendRealtimeUpdate();
    }
    sendRealtimeUpdate() {
        const symbol = TvSymbolConvertor.getFullname(this.instrument);
        const account = TvAccountHelper.getCurrentAccount();
        const askPrice = this.instrument.Level1.GetAsk(account);
        const bidPrice = this.instrument.Level1.GetBid(account);
        const spreadPrice = askPrice - bidPrice;
        const tradeQuote = {
            ask: TvQuoteUtils.replaceNaN(askPrice),
            bid: TvQuoteUtils.replaceNaN(bidPrice),
            trade: TvQuoteUtils.replaceNaN(this.instrument.Level1.GetLastPrice(account)),
            spread: TvQuoteUtils.replaceNaN(spreadPrice),
            bid_size: TvQuoteUtils.replaceNaN(this.instrument.Level1.getBidSize(true)),
            ask_size: TvQuoteUtils.replaceNaN(this.instrument.Level1.getAskSize(true)),
            size: TvQuoteUtils.replaceNaN(this.instrument.Level1.GetLastSize(true)),
            isDelayed: this.isDelayed
            // isHalted?: boolean;
            // isHardToBorrow?: boolean;
            // isNotShortable?: boolean;
        };
        this.host.realtimeUpdate(symbol, tradeQuote);
    }
}
TvInstrumentQuoteManager.THROTTLE_DELAY = 200;
